import { FC } from 'react'
import { Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import FormModal from '../../../../../../../components/form-modal/form-modal'
import EditForm from './components/edit-form/edit-form'

interface EditProps {
    documentId: string
}

const Edit: FC<EditProps> = ({ documentId }) => {
    return (
        <>
            <FormModal
                title={'Заказы материалов'}
                width={1200}
                renderOpener={onOpen => (
                    <Button
                        size={'small'}
                        icon={<EditOutlined />}
                        color='primary'
                        variant={'outlined'}
                        title={'Редактировать заказ'}
                        onClick={onOpen}
                    />
                )}
                renderContent={onClose => (
                    <EditForm
                        documentId={documentId}
                        onSuccess={() => {
                            onClose()
                        }}
                    />
                )}
            />
        </>
    )
}

export default Edit
